import { Component, OnInit } from '@angular/core';
import {Form, FormBuilder, FormGroup, NgForm} from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MatFormFieldControl } from '@angular/material/form-field';
import {EntidadeService} from "../../service/entidade/entidade.service";
import {ToasterService} from "angular2-toaster";
import {BlockUI, NgBlockUI} from "ng-block-ui";
import {PrecatorioPagoDTO} from "../../../models/precatorioPagoDTO";
import {PageEvent} from "@angular/material/paginator";
import { Title } from '@angular/platform-browser';

@Component({
  selector: 'app-lista-precatorios-pagos',
  templateUrl: './lista-precatorios-pagos.component.html',
  styleUrls: ['./lista-precatorios-pagos.component.css'],
  providers: [ MatDialog, { provide: MatFormFieldControl, useExisting: FormBuilder }]
})
export class ListaPrecatoriosPagosComponent implements OnInit {


  pageNumber:number;
  pageSize:number;
  enteDevedores: Array<any> = new Array();
  listaPrecatorios: PrecatorioPagoDTO[] = [];
  filtrosPesquisaForm: FormGroup;
  displayedColumns: String[] = ['numeroPrecatorio','dataPagamento','tipoPagamento','totalPago'];
    naturezas: any = [
        { id: 'TODOS', valor: 'TODOS' },
        { id: 'A', valor: 'ALIMENTAR' },
        { id: 'C', valor: 'COMUM' }
    ];
  totalElements: number = 0;
  mostrarResultado: boolean;
  @BlockUI() blockUI: NgBlockUI;
  @BlockUI('conteudo-captcha') blockUIList: NgBlockUI;
  token: string | undefined;
  private captchaResolvida: boolean;

  constructor(private formBuilder: FormBuilder,
              private entidadeService: EntidadeService,
              private toast: ToasterService,
              private titleService: Title) {
    this.token = undefined;
    this.captchaResolvida = false;
  }

  ngOnInit(): void {
    this.limparFiltros();
    this.pageNumber = 0;
    this.pageSize = 20;
    this.mostrarResultado = false;
    this.titleService.setTitle("Lista de Precatórios Pagos");
    this.blockUIList.start();
  }

  limparFiltros(){
    this.filtrosPesquisaForm = this.formBuilder.group({
      devedor: 0,
      numeroPrecatorio: "",
      dataInicio: "",
      dataFim: "",
      natureza: "TODOS"
    })
  }

  isGroup(index, item):boolean{
    return item.groupHeader;
  }
  public validarCaptcha(form: NgForm): void {
    if (form.invalid) {
      for (const control of Object.keys(form.controls)) {
        form.controls[control].markAsTouched();
      }
      return;
    }
    this.listaEnteDevedor();
    this.blockUIList.stop();
    this.captchaResolvida = true;
  }

  listaEnteDevedor() {

    this.entidadeService.listEnteDevedor().subscribe(data => {
      this.enteDevedores = data;
    }, error => {
      console.error(error);
    });
  }

  private listarPrecatorios(mostrarTodos: boolean) {
    this.blockUI.start();
    this.listaPrecatorios.length = 0;
    this.entidadeService.buscarPrecatoriosPagosPorFiltro(this.getFiltro(mostrarTodos)).subscribe(data => {
      this.listaPrecatorios = data.content as PrecatorioPagoDTO[];
      if(this.pageNumber == 0){
        this.totalElements = data.totalElements;
      }
      if(this.listaPrecatorios.length>0){
        this.mostrarResultado = true;
      }else{
        this.toast.pop('warning', 'Nenhum resultado encontrado.')
      }

      if (mostrarTodos) {
        this.pageSize = this.listaPrecatorios.length;
      }
      this.blockUI.stop();
    },
    error => {
      this.blockUI.stop();
      this.toast.pop('warning', 'Nenhum resultado encontrado.');
    });
  }

  private getFiltro(mostrarTodos:boolean): any {
    const filtro:any = {};

    filtro.enteDevedor = this.filtrosPesquisaForm.get('devedor').value;
    filtro.numPrecatorio = this.filtrosPesquisaForm.get('numeroPrecatorio').value;
    filtro.dataInicio = this.filtrosPesquisaForm.get('dataInicio').value;
    filtro.dataFim = this.filtrosPesquisaForm.get('dataFim').value;
    filtro.natureza = this.filtrosPesquisaForm.get('natureza').value;
    filtro.mostrarTodos = mostrarTodos;
    filtro.page = this.pageNumber+1;
    filtro.size = this.pageSize;

    return filtro;
  }

  pesquisar(mostrarTodos:boolean) {
    this.pageNumber = 0;
    this.pageSize = 20;
    this.mostrarResultado = false;

    if (!this.captchaResolvida) {
      this.toast.pop('warning', 'Resolva a captcha', 'É necessário resolver a captcha para pesquisar!');
      return;
    }

    if(this.filtrosPesquisaForm.get('numeroPrecatorio').value == '') {
      if(this.filtrosPesquisaForm.get('dataInicio').value == 0 ||
        this.filtrosPesquisaForm.get('dataFim').value == 0 ) {
          this.toast.pop('warning', 'Obrigatório selecionar um período');
      }
      else if (this.filtrosPesquisaForm.get('dataInicio').value.length != 10 ||
        this.filtrosPesquisaForm.get('dataFim').value.length != 10) {
          this.toast.pop('warning','Período selecionado é invalido','Por favor verifique e tente novamente');
      }
      else if(this.filtrosPesquisaForm.get('dataInicio').value >
        this.filtrosPesquisaForm.get('dataFim').value ) {
          this.toast.pop('warning', 'Data de início maior que data de fim','Por Favor corrija e repita o processo');
      } else {
        this.listarPrecatorios(mostrarTodos);
      }
      
    } else {
      this.listarPrecatorios(mostrarTodos);
    }

    
  }

  nextPage(e: PageEvent) {
    this.pageNumber = e.pageIndex;
    this.pageSize = e.pageSize;
    this.listarPrecatorios(false);
  }

}
